import { ChevronDown, ChevronRight } from 'react-feather';

/** Expand/collapse caret — matches Credora360 (react-feather, not Font Awesome). */
export function SidebarChevron({
  open,
  className = 'according-menu',
}: {
  open: boolean;
  className?: string;
}) {
  const Icon = open ? ChevronDown : ChevronRight;
  return (
    <div className={className}>
      <Icon size={16} strokeWidth={2} aria-hidden />
    </div>
  );
}
